/* eslint-disable react/prop-types */
import React, { Fragment, useEffect, useState } from 'react';

import {
	Button,
	Grid,
	Typography,
	Select,
	MenuItem,
	Modal,
	FormControl,
	TextField,
	Snackbar,
} from '@mui/material';
import Menu from '@mui/material/Menu';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { Scheduler } from '@aldabil/react-scheduler';
import Box from '@mui/material/Box';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';

import {
	ClockIcon,
	DatePicker,
	DateTimePicker,
	LocalizationProvider,
} from '@mui/x-date-pickers';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { Menu } from '@mui/joy';
import { useStateValue } from '../../../services/state/State';
import {
	addAppointment,
	getAppointment,
	getLocation,
	getPatientList,
	getPracticeStaff,
	updateAppointment,
} from '../../../services/api/apiManager';
import { Cancel, MoreVert, Refresh } from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: 'white',
	fontFamily: 'Poppins',
	borderRadius: '10px',
	width: 'min(920px, calc(100vw - 48px))',
	border: '1px solid #dce6f3',
	boxShadow: '0 10px 30px rgba(16, 24, 40, 0.14)',
	outline: 'none',
};

function Schedular(props) {
	const filterFieldSx = {
		'& .MuiInputBase-root': {
			height: 40,
			borderRadius: '6px',
			backgroundColor: '#fff',
			fontFamily: 'Poppins',
			fontSize: '13px',
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#d6e2f2',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#b9cbe3',
		},
		'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#2E68BA',
			borderWidth: '1px',
		},
		'& .MuiInputBase-input': {
			color: '#122b55',
			fontSize: '13px',
			padding: '9px 12px',
		},
	};
	const filterLabelSx = {
		mb: 0.5,
		fontFamily: 'Poppins',
		fontSize: '12px',
		fontWeight: 600,
		color: '#172d58',
	};
	const modalLabelSx = {
		fontFamily: 'Poppins',
		fontSize: '13px',
		fontWeight: 600,
		color: '#172d58',
		mb: 0.5,
	};
	const modalControlSx = {
		width: '100%',
		'& .MuiInputBase-root': {
			height: 50,
			minHeight: 50,
			borderRadius: '8px',
			backgroundColor: '#fff',
			fontFamily: 'Poppins',
			fontSize: '13px',
		},
		'& .MuiFormControl-root': {
			width: '100%',
		},
		'& .MuiAutocomplete-inputRoot': {
			height: '50px !important',
			minHeight: '50px !important',
			paddingTop: '0 !important',
			paddingBottom: '0 !important',
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#d6e2f2',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#b9cbe3',
		},
		'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#2E68BA',
			borderWidth: '1px',
		},
		'& .MuiInputBase-input': {
			height: 'auto',
			padding: '12px 14px',
			color: '#122b55',
			fontSize: '13px',
			boxSizing: 'border-box',
		},
	};
	const modalMenuProps = {
		PaperProps: {
			sx: {
				mt: 0.5,
				maxHeight: 260,
				borderRadius: '8px',
				boxShadow: '0 8px 24px rgba(16, 24, 40, 0.14)',
				'& .MuiMenuItem-root': {
					fontFamily: 'Poppins',
					fontSize: '13px',
					minHeight: 34,
					py: 0.75,
				},
				'& .MuiMenuItem-root.Mui-selected': {
					backgroundColor: '#edf5ff',
				},
				'& .MuiMenuItem-root.Mui-selected:hover': {
					backgroundColor: '#e5f0ff',
				},
			},
		},
	};

	const [loading, setLoading] = useState(false);
	const practiceId = localStorage.getItem('practice_id');
	const [{ locations, practice }] = useStateValue();
	const [patientList, setPatientList] = useState([]);
	const [location, setLocation] = useState([]);
	const [providerList, setProviderList] = useState([]);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [selectedDate, setselectedDate] = useState(dayjs(new Date()));
	const [updateReason, setUpdateReason] = useState('');
	const [updateProvider, setUpdateProvider] = useState('');
	const [updateLocation, setUpdateLocation] = useState('');
	const [udatePatientName, setUpdatePatientName] = useState('');
	const [updateAppointmentStatus, setUpdateAppointmentStatus] = useState('P');
	const [appointmentID, setAppointmentID] = useState(0);
	const [invalidInfo, setInvalidInfo] = useState(false);
	const [updateAppointmentData, setUpdateAppointmentData] = useState({
		patient_id: 130,
		provider_id: 9,
		location_id: 5,
		AppointmentDate: dayjs(selectedDate).format('YYYY-MM-DDTHH:mm'),
		Status: 'P',
		Reason: 'Right Fight',
	});
	const [provider, setProvider] = React.useState('');
	const [staffList, setStaffList] = useState([]);
	const [filterLocation, setFilterLocation] = React.useState('');
	const [selectedFilterDate, setSelectedFilterDate] = useState(null);
	const [appointmentList, setAppointmentList] = useState([]);

	const [filteredAppointments, setFilteredAppointments] = useState([]);

	const handleProvider = (event) => {
		const selectedProvider = event.target.value;
		setProvider(selectedProvider);

		const filterAppointmentss = selectedProvider
			? appointmentList?.filter((appointment) => {
					if (filterLocation === '') {
						return appointment.provider_id === parseInt(selectedProvider);
					} else if (filterLocation !== '') {
						return (
							appointment.provider_id === parseInt(selectedProvider) &&
							appointment.location_id === parseInt(filterLocation)
						);
					}
				})
			: appointmentList;
		setFilteredAppointments(filterAppointmentss);
	};
	const handleFilterLocation = (e) => {
		setFilterLocation(e.target.value);
		const filterAppointmentss = e.target.value
			? appointmentList?.filter((appointment) => {
					if (provider === '') {
						return appointment?.location_id === parseInt(e.target.value);
					} else if (provider !== '') {
						return (
							appointment?.location_id === parseInt(e.target.value) &&
							appointment?.provider_id === parseInt(provider)
						);
					}
				})
			: appointmentList;
		setFilteredAppointments(filterAppointmentss);
	};
	const handleDateChange = (date) => {
		const dataSelect = date;
		setSelectedFilterDate(dataSelect);
		const filterAppointments = dataSelect
			? appointmentList?.filter((appointment) => {
					const formattedAppointmentDate = new Date(appointment?.start)
						.toISOString()
						.split('T')[0];

					return formattedAppointmentDate === dataSelect?.format('YYYY-MM-DD');
				})
			: appointmentList;

		setFilteredAppointments(filterAppointments);
	};
	const fetchAppointments = async () => {
		setLoading(true);
		const res = await getAppointment();
		if (res?.status === 200) {
			const appointmentsAccording_toLibrary_format = res?.data
				?.filter((items) => items?.patient?.practice_id == practiceId)
				.map((items) => {
					return {
						locationName: items?.location?.Name,
						event_id: items?.id,
						title:
							items?.Reason == ''
								? 'Reason Not Written'
								: items?.Reason === null
									? 'Reason Not Mention'
									: items?.Reason,
						start: new Date(items?.AppointmentDate),
						end: new Date(
							new Date(items?.AppointmentDate)?.setTime(
								new Date(items?.AppointmentDate)?.getTime() + 30 * 60 * 1000
							)
						),
						admin_id: items?.id,
						patientFullName:
							items?.patient?.Fname + ' ' + items?.patient?.Lname,
						patient_id: items?.patient_id,
						provider_id: items?.provider_id,
						Status: items?.Status,
						location_id: items?.location_id,
						color:
							items?.Status === 'C'
								? 'green'
								: items?.Status === 'D'
									? 'red'
									: items?.Status === 'O'
										? 'grey'
										: 'yellow',
						textColor:
							items?.Status === 'C'
								? 'White'
								: items?.Status === 'D'
									? 'Wheat'
									: 'Black',
						editable: false,
						deletable: false,
						draggable: false,
					};
				});
			setAppointmentList(appointmentsAccording_toLibrary_format);
			setFilteredAppointments(appointmentsAccording_toLibrary_format);
			setLoading(false);
		} else if (res?.status === undefined) {
			setAppointmentList([]);
			setFilteredAppointments([]);
		}
	};
	// add appointment start
	const [openAdd, setOpenAdd] = React.useState(false);
	const [appointment, setappoitment] = useState({
		// practice_id: practice_id,
		patient_id: '',
		provider_id: '',
		location_id: '',
		AppointmentDate: dayjs(selectedDate).format('YYYY-MM-DDTHH:mm:ss'),
		Status: '',
		Reason: '',
	});
	const handleOpenAddAppointment = () => setOpenAdd(true);
	const handleCloseModal = () => {
		setappoitment({
			patient_id: '',
			provider_id: '',
			AppointmentDate: dayjs(selectedDate),
			location_id: '',
			Status: 'P',
			Reason: '',
		});
		setOpenAdd(false);
	};
	// for adding new appointments
	const addNewAppointment = async (data) => {
		const resp = await addAppointment(data);
		if (resp.status === 201) {
			setPostSucessfully(true);
			setOpenSnackbar(true);
			handleCloseModal();
			setappoitment({
				patient_id: '',
				provider_id: '',
				AppointmentDate: dayjs(selectedDate).format('YYYY-MM-DDTHH:mm:ss'),
				Status: 'P',
				location_id: '',
				Reason: '',
			});
			fetchAppointments();
			setselectedDate(dayjs(new Date()));
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};
	// add appointment end
	const handleReset = () => {
		setProvider('');
		setFilterLocation('');
		setSelectedFilterDate(null);
		setFilteredAppointments(appointmentList);
	};
	const fetchPracticeStaff = async () => {
		const res = await getPracticeStaff();
		if (res && res.data && res.data.length > 0) {
			setStaffList(res.data);
		} else {
			setStaffList([]);
		}
	};
	const mappingProviderList =
		staffList &&
		staffList?.map((row) => ({
			name: row?.Fname + ' ' + row?.Lname,
			providerId: row?.id,
		}));
	const [open, setOpen] = React.useState(false);

	// from this function modal is opening and selected events values of schedular are setting
	const Add = (event) => {
		setUpdateAppointmentData({
			patient_id: event?.patient_id,
			provider_id: event?.provider_id,
			location_id: event?.location_id,
			AppointmentDate: dayjs(event?.start).format('YYYY-MM-DDTHH:mm:ss'),
			Status: event?.Status,
			Reason: event?.title,
		});
		// when modal opening all values will be according to patient appointment
		setUpdatePatientName(event?.patient_id);
		setUpdateAppointmentStatus(event?.Status);
		setUpdateProvider(event?.provider_id);
		setUpdateLocation(event?.location_id);
		setUpdateReason(event?.title);
		setselectedDate(dayjs(event?.start));
		setAppointmentID(event?.event_id);
		setOpen(true);
	};
	const handleClose = () => setOpen(false);

	const handleCloseSnackbar = () => setOpenSnackbar(false);

	// Modal Delete with these state values are shown in delete Modal
	const [openDeleteModal, setOpenDeleteModal] = useState({
		deleteModalOpen: false,
		deletingId: '',
		deletingName: '',
		deletingReason: '',
	});
	const handleOpenDeleteModal = (data) => {
		setOpenDeleteModal({
			deleteModalOpen: true,
			deletingId: data?.event_id,
			deletingName: data?.patientFullName,
			deletingReason: data?.Reason,
		});
	};
	const handleCloseDeleteModal = () => {
		setOpenDeleteModal({
			deleteModalOpen: false,
			deletingId: '',
			deletingName: '',
			deletingReason: '',
		});
	};

	const fetchPatientList = async (id) => {
		const resp = await getPatientList(id);
		if (resp?.status === 200) {
			setPatientList(resp?.data);
		} else {
			setPatientList([]);
		}
	};

	const fetchProviderList = async () => {
		const res = await getPracticeStaff();
		if (res && res.data && res.data.length > 0) {
			setProviderList(res?.data);
		} else {
			setProviderList([]);
		}
	};

	const getLocationsData = async () => {
		const resp = await getLocation();
		if (resp?.status === 200) {
			setLocation(resp?.data);
		}
	};

	const updateAppointmentInfo = async (id, data) => {
		const resp = await updateAppointment(id, data);
		if (resp?.status === 200) {
			setPostSucessfully(true);
			setOpen(false);
			fetchAppointments();
			props.updatingSnackbar(true);
			if (resp?.data.Deleted === true) {
				handleCloseDeleteModal();
				props.deletingAppointment(true);
			}

			setOpenSnackbar(true);
		} else if (resp?.status === undefined) {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};

	useEffect(() => {
		fetchPracticeStaff();
		fetchPatientList(practiceId);
		getLocationsData();
		fetchProviderList();
		fetchAppointments();
	}, []);
	useEffect(() => {
		fetchAppointments();
	}, [props?.reRenderFromParent]);
	return (
		<Fragment>
			{/* {<h2>{props.reRenderFromParent?.toString()}</h2>} */}
			<Grid container item xs={12} lg={12} xl={12} md={12} sm={12}>
				<Grid
					container
					item
					sx={{
						p: 1.5,
						background: '#fff',
						border: '1px solid #dce6f3',
						borderRadius: '8px',
						display: 'flex',
						alignItems: 'flex-end',
						gap: 1.5,
						flexWrap: 'wrap',
					}}
				>
					<Grid
						item
						xs={12}
						sm={6}
						md={3}
						xl={3}
						lg={3}
						sx={{ p: 0, minWidth: 210 }}
					>
						<Box>
							<Typography sx={filterLabelSx}>Provider</Typography>
							<FormControl size="small" fullWidth>
								<Select
									defaultValue=""
									name="providerFilter"
									value={provider}
									onChange={handleProvider}
									inputProps={{ 'aria-label': 'Without label' }}
									displayEmpty
									sx={{
										...filterFieldSx,
									}}
									MenuProps={{
										PaperProps: {
											style: {
												maxHeight: 260,
											},
										},
									}}
								>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>
										Select provider
									</MenuItem>
									{mappingProviderList &&
										mappingProviderList.length > 0 &&
										mappingProviderList.map((pl, index) => (
											<MenuItem key={index} value={pl.providerId}>
												{pl?.name}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={6}
						md={3}
						xl={3}
						lg={3}
						sx={{ p: 0, minWidth: 210 }}
					>
						<Box>
							<FormControl
								size="small"
								fullWidth
								inputProps={{ 'aria-label': 'Without label' }}
							>
								<Typography sx={filterLabelSx}>Location</Typography>
								<Select
									defaultValue=""
									name="locationFilterID"
									inputProps={{ 'aria-label': 'Without label' }}
									MenuProps={{
										PaperProps: {
											style: {
												maxHeight: 260,
											},
										},
									}}
									value={filterLocation}
									onChange={handleFilterLocation}
									displayEmpty
									sx={{
										...filterFieldSx,
									}}
								>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>
										Select location
									</MenuItem>
									{location?.map((items, index) => {
										return (
											<MenuItem key={index} value={items?.id}>
												{items?.Name}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={6}
						md={3}
						xl={3}
						lg={3}
						sx={{ p: 0, minWidth: 210 }}
					>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'flex-end',
								gap: 1,
							}}
						>
							<Box sx={{ flex: 1 }}>
								<Typography sx={filterLabelSx}>Date</Typography>
								<LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
									<DemoContainer
										components={['DatePicker']}
										sx={{ p: 0, overflow: 'visible', width: '100%' }}
									>
										<DemoItem sx={{ width: '100%' }}>
										{/* <DatePicker
														label="Date"
														size="small"
														sx={{
															borderLeft: '6px solid #DA8541',
															borderRadius: '7px',
															width: '100%',
														}}
														slotProps={{ textField: { size: 'small' } }}
														value={selectedFilterDate}
														onChange={handleDateChange}
													/> */}

										<DatePicker
											sx={{ width: '100%' }}
											slotProps={{
												textField: {
													size: 'small',
													placeholder: 'MM/DD/YYYY',
													sx: filterFieldSx,
												},
											}}
											value={selectedFilterDate}
											onChange={handleDateChange}
										/>
									</DemoItem>
								</DemoContainer>
							</LocalizationProvider>
							</Box>
							<Button
								onClick={handleReset}
								variant="contained"
								size="medium"
								color="success"
								sx={{
									minWidth: 40,
									width: 40,
									height: 40,
									borderRadius: '6px',
									boxShadow: 'none',
									bgcolor: '#2e7d32',
									'&:hover': { bgcolor: '#1f6c29' },
								}}
							>
								<Refresh />
							</Button>
						</Box>
					</Grid>
					<Grid
						item
						xs={12}
						sm={6}
						md={2}
						xl={2}
						lg={2}
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							alignItems: 'center',
							p: 0,
							ml: 'auto',
						}}
					>
						<Button
							onClick={handleOpenAddAppointment}
							startIcon={<PersonAddIcon />}
							sx={{
								color: 'white',
								background: '#2E68BA',
								fontWeight: 600,
								fontFamily: 'Poppins',
								height: 40,
								borderRadius: '6px',
								px: 2.5,
								whiteSpace: 'nowrap',
								boxShadow: '0 2px 6px rgba(46, 104, 186, 0.25)',
								'&:hover': {
									background: '#265aa8',
								},
							}}
						>
							Add
						</Button>
					</Grid>
				</Grid>

				<Grid
					item
					xs={12}
					lg={12}
					xl={12}
					md={12}
					sm={12}
					sx={{
						height: {
							xl: '75vh',
							lg: '70vh',
							md: '65vh',
							sm: '65vh',
							xs: '85vh',
						},
						overflow: 'auto',
						border: '0.5px solid lightgray',
					}}
				>
					{loading ? (
						<BrandedLoader
							title="Loading appointments"
							text="Preparing appointment schedule"
						/>
					) : !loading && filteredAppointments?.length === 0 ? (
						<Box
							width={'100%'}
							display={'flex'}
							justifyContent={'center'}
							alignItems={'center'}
							height={'50vh'}
							color={'red'}
						>
							No Appointment{' '}
						</Box>
					) : (
						<Scheduler
							disableAddEvent={true}
							editable={false}
							deletable={false}
							agenda={false}
							disableViewNavigator={true}
							resourceViewMode="default"
							day={{ navigation: false }}
							// navigation={false}
							stickyNavigation
							week={{
								startHour: 8,
								endHour: 23,
								navigation: true,
								disableGoToDay: true,
								step: 50,
							}}
							view="week"
							events={filteredAppointments}
							// for adding your own popper-dialog while clicking on any event
							customViewer={(event, closePopper) => {
								const statusMeta =
									event?.Status === 'C'
										? { label: 'Confirmed', color: '#0a8f3a', bg: '#eaf8ef' }
										: event?.Status === 'D'
											? { label: 'Dismissed', color: '#e33c3c', bg: '#ffecec' }
											: event?.Status === 'O'
												? { label: 'Other', color: '#6b7280', bg: '#eef2f7' }
												: { label: 'Pending', color: '#ff9f0a', bg: '#fff4df' };
								const detailRowSx = {
									display: 'grid',
									gridTemplateColumns: '92px minmax(0, 1fr)',
									alignItems: 'center',
									columnGap: '10px',
									minHeight: '28px',
								};
								const detailLabelSx = {
									fontFamily: 'Poppins',
									fontSize: '12px',
									fontWeight: 600,
									color: '#5b6b86',
								};
								const detailValueSx = {
									fontFamily: 'Poppins',
									fontSize: '12px',
									fontWeight: 500,
									color: '#102a54',
									textAlign: 'right',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
								};
								return (
									<>
										<Box
											sx={{
												width: 320,
												maxWidth: 'calc(100vw - 32px)',
												borderRadius: '8px',
												border: '1px solid #d8e4f3',
												overflow: 'hidden',
												backgroundColor: '#fff',
												boxShadow: '0 16px 34px rgba(15, 23, 42, 0.18)',
												fontFamily: 'Poppins',
											}}
										>
											<Box
												sx={{
													width: '100%',
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													gap: 1,
													padding: '10px 10px 10px 12px',
													borderBottom: '1px solid #edf2f8',
													backgroundColor: '#f8fbff',
												}}
											>
												<Typography
													sx={{
														fontFamily: 'Poppins',
														fontSize: '13px',
														fontWeight: 600,
														color: '#102a54',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													{event?.patientFullName}
												</Typography>
												<PopupState variant="popover" popupId="demo-popup-menu">
													{(popupState) => (
														<React.Fragment>
															<MoreVert
																variant="contained"
																{...bindTrigger(popupState)}
																sx={{
																	cursor: 'pointer',
																	color: '#405574',
																	fontSize: '20px',
																	flexShrink: 0,
																}}
															/>
															<Menu
																{...bindMenu(popupState)}
																PaperProps={{
																	sx: {
																		mt: 0.5,
																		borderRadius: '8px',
																		boxShadow: '0 12px 28px rgba(15, 23, 42, 0.16)',
																		'& .MuiMenuItem-root': {
																			fontFamily: 'Poppins',
																			fontSize: '13px',
																			minHeight: 34,
																		},
																	},
																}}
															>
																<MenuItem
																	onClick={() => {
																		Add(event);
																		popupState.close();
																		closePopper(); //this will close your appointment customViewer
																	}}
																>
																	Edit
																</MenuItem>
																<MenuItem
																	onClick={() => {
																		handleOpenDeleteModal(event);
																		closePopper();
																	}}
																>
																	Delete
																</MenuItem>
															</Menu>
														</React.Fragment>
													)}
												</PopupState>
											</Box>
											<Box sx={{ padding: '10px 12px 8px' }}>
												<Box sx={detailRowSx}>
													<Typography sx={detailLabelSx}>Location</Typography>
													<Typography sx={detailValueSx}>{event?.locationName || '-'}</Typography>
												</Box>
												<Box sx={detailRowSx}>
													<Typography sx={detailLabelSx}>Reason</Typography>
													<Typography sx={detailValueSx}>{event?.title || '-'}</Typography>
												</Box>
												<Box sx={detailRowSx}>
													<Typography sx={detailLabelSx}>Status</Typography>
													<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
														<Box
															sx={{
																display: 'inline-flex',
																alignItems: 'center',
																gap: '6px',
																padding: '4px 10px',
																borderRadius: '999px',
																backgroundColor: statusMeta.bg,
																color: statusMeta.color,
																fontFamily: 'Poppins',
																fontSize: '12px',
																fontWeight: 600,
																lineHeight: 1,
															}}
														>
															<Box
																component="span"
																sx={{
																	width: 6,
																	height: 6,
																	borderRadius: '50%',
																	backgroundColor: statusMeta.color,
																	flexShrink: 0,
																}}
															/>
															{statusMeta.label}
														</Box>
													</Box>
												</Box>
											</Box>
											<Box
												sx={{
													display: 'flex',
													width: '100%',
													gap: '8px',
													justifyContent: 'center',
													alignItems: 'center',
													padding: '9px 12px',
													borderTop: '1px solid #edf2f8',
													backgroundColor: '#fbfdff',
												}}
											>
												<ClockIcon sx={{ color: '#2E68BA', fontSize: 18 }} />
												<Typography
													sx={{
														fontFamily: 'Poppins',
														fontSize: '12px',
														fontWeight: 600,
														color: '#102a54',
													}}
												>
													{dayjs(event?.start).format('DD/MM/YYYY hh:mm:ss A')}
												</Typography>
											</Box>
										</Box>
									</>
								);
							}}
						/>
					)}
				</Grid>
			</Grid>
			{/* add appointment modal */}
			<Modal
				open={openAdd}
				onClose={handleCloseModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box
						sx={{
							width: '100%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							px: 2,
							height: 44,
							borderBottom: '1px solid #dce6f3',
						}}
					>
						<Typography
							id="modal-modal-title"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '18px',
								fontWeight: 700,
								color: '#172d58',
							}}
						>
							Add Appointment
						</Typography>
						<Cancel
							sx={{ cursor: 'pointer', color: '#172d58' }}
							onClick={() => {
								handleCloseModal();
								setInvalidInfo(false);
								setappoitment({
									patient_id: '',
									provider_id: '',
									AppointmentDate: dayjs(selectedDate),
									location_id: '',
									Status: 'P',
									Reason: '',
								});
							}}
						/>
					</Box>
					{invalidInfo && (
						<Box
							display={
								appointment?.patient_id === ''
									? ''
									: appointment?.provider_id === ''
										? ''
										: appointment?.Status === ''
											? ''
											: appointment?.Reason === ''
												? ''
												: appointment?.AppointmentDate == 'Invalid Date'
													? ''
													: appointment?.location_id === ''
														? ''
														: 'none'
							}
						>
							<Alert variant="filled" severity="error">
								Please Fill all Information!
							</Alert>
						</Box>
					)}
					<Grid container spacing={1.5} sx={{ p: 1.5 }}>
						<Grid item xs={12} md={4}>
							<Typography sx={modalLabelSx}>Select Patient</Typography>
							<FormControl fullWidth size="small" sx={modalControlSx}>
								<Select
									defaultValue=""
									value={appointment?.patient_id}
									displayEmpty
									MenuProps={modalMenuProps}
									onChange={(e) => {
										setappoitment((prev) => ({
											...prev,
											patient_id: e.target.value,
											provider_id: (patientList?.filter(
												(items) => items?.patient_id === e.target.value
											))[0]?.providerid,
											location_id: (patientList?.filter(
												(items) => items?.patient_id === e.target.value
											))[0]?.locationid,
										}));
									}}
								>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>Select Patient</MenuItem>
									{patientList?.map((items, index) => (
										<MenuItem key={index} value={items?.patient_id}>
											{items?.Name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={4}>
							<Typography sx={modalLabelSx}>Provider Name</Typography>
							<FormControl fullWidth size="small" sx={modalControlSx}>
								<Select defaultValue="" value={appointment?.provider_id} displayEmpty MenuProps={modalMenuProps} onChange={(e) => setappoitment((prev) => ({ ...prev, provider_id: e.target.value }))}>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>Select Provider</MenuItem>
									{mappingProviderList?.map((item, index) => (
										<MenuItem key={index} value={item?.providerId}>{item?.name}</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={4}>
							<Typography sx={modalLabelSx}>Appointment Status</Typography>
							<FormControl fullWidth size="small" sx={modalControlSx}>
								<Select defaultValue="" value={appointment?.Status} displayEmpty MenuProps={modalMenuProps} name="Status" onChange={(e) => setappoitment((prev) => ({ ...prev, Status: e.target.value }))}>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>Select Status</MenuItem>
									<MenuItem value={'C'}>Completed</MenuItem>
									<MenuItem value={'D'}>Dismissed</MenuItem>
									<MenuItem value={'O'}>Other</MenuItem>
									<MenuItem value={'P'}>Pending</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={6}>
							<Typography sx={modalLabelSx}>Location</Typography>
							<FormControl fullWidth size="small" sx={modalControlSx}>
								<Select defaultValue="" value={appointment?.location_id} displayEmpty MenuProps={modalMenuProps} onChange={(e) => setappoitment((prev) => ({ ...prev, location_id: e.target.value }))}>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>Select Location</MenuItem>
									{location?.map((items, index) => (
										<MenuItem key={index} value={items?.id}>{items?.Name}</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={6}>
							<Typography sx={modalLabelSx}>Appointment Date & Time</Typography>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DemoContainer components={['DateTimePicker']} sx={{ p: 0 }}>
									<DemoItem>
										<DateTimePicker
											orientation="portrait"
											disablePast
											size="small"
											slotProps={{ textField: { size: 'small', sx: modalControlSx, placeholder: 'MM/DD/YYYY hh:mm AM/PM' } }}
											sx={{ width: '100%' }}
											value={selectedDate}
											onChange={(nValue) => {
												setselectedDate(nValue);
												setappoitment((prev) => ({
													...prev,
													AppointmentDate: dayjs(nValue).format('YYYY-MM-DDTHH:mm:ss'),
												}));
											}}
										/>
									</DemoItem>
								</DemoContainer>
							</LocalizationProvider>
						</Grid>
						<Grid item xs={12}>
							<Typography sx={modalLabelSx}>Reason</Typography>
							<Box
								component="textarea"
								name="Reason"
								placeholder="Enter Reason..."
								value={appointment?.Reason}
								onChange={(e) => setappoitment((prev) => ({ ...prev, Reason: e.target.value }))}
								sx={{
									width: '100%',
									minHeight: 92,
									resize: 'vertical',
									border: '1px solid #d6e2f2',
									borderRadius: '8px',
									padding: '12px 14px',
									fontFamily: 'Poppins',
									fontSize: '13px',
									color: '#122b55',
									outline: 'none',
									boxSizing: 'border-box',
									'&::placeholder': { color: '#8a9ab5' },
									'&:focus': { borderColor: '#2E68BA' },
								}}
							/>
						</Grid>
					</Grid>
					<Grid
						item
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: '5px',
							padding: '13px 8px 0px 8px',
						}}
						xs={12}
					>
						<Button
							onClick={() => {
								handleCloseModal();
								setInvalidInfo(false);
								setappoitment({
									patient_id: '',
									provider_id: '',
									AppointmentDate: dayjs(new Date()),
									location_id: '',
									Status: 'P',
									Reason: '',
								});
								setselectedDate(dayjs(new Date()));
							}}
							sx={{
								mb: 1,
								background: '#fff',
								border: '1px solid #cfd8e6',
								color: '#445273',
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 600,
								borderRadius: '10px',
								padding: '10px 26px',
								'&:hover': {
									background: '#f8fbff',
									border: '1px solid #cfd8e6',
								},
							}}
						>
							Cancel
						</Button>

						<Button
							sx={{
								mb: 1,
								background: '#2E68BA',
								border: '1px solid #2E68BA',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 600,
								borderRadius: '10px',
								padding: '10px 26px',
								'&:hover': {
									background: '#265aa8',
									border: '1px solid #265aa8',
								},
							}}
							onClick={() => {
								if (
									appointment?.patient_id === '' ||
									appointment?.provider_id === '' ||
									appointment?.Status === '' ||
									appointment?.Reason === '' ||
									appointment?.AppointmentDate == 'Invalid Date' ||
									appointment?.location_id === ''
								) {
									setInvalidInfo(true);
								} else {
									addNewAppointment(appointment);
								}
							}}
						>
							Add Appointment
						</Button>
					</Grid>
				</Box>
			</Modal>
			{/*Update Modal Code is Starts From here */}
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box
						sx={{
							width: '100%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							px: 2,
							height: 44,
							borderBottom: '1px solid #dce6f3',
						}}
					>
						<Typography
							id="modal-modal-title"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '18px',
								fontWeight: 700,
								color: '#172d58',
							}}
						>
							Update Appointment
						</Typography>
						<Cancel
							sx={{ cursor: 'pointer', color: '#172d58' }}
							onClick={() => {
								setOpen(false);
							}}
						/>
					</Box>
					{
						<Box
							display={
								updateAppointmentData?.patient_id === ''
									? ''
									: updateAppointmentData?.provider_id === ''
										? ''
										: updateAppointmentData?.Status === ''
											? ''
											: updateAppointmentData?.Reason === ''
												? ''
												: updateAppointmentData?.location_id === ''
													? ''
													: updateAppointmentData?.AppointmentDate ==
														  'Invalid Date'
														? ''
														: 'none'
							}
						>
							<Alert variant="filled" severity="error">
								Please Fill all Information!
							</Alert>
						</Box>
					}
					<Grid container spacing={1.5} sx={{ p: 1.5 }}>
						<Grid item xs={12} md={4}>
							<Typography sx={modalLabelSx}>Select Patient</Typography>
							<FormControl fullWidth size="small" sx={modalControlSx}>
								<Select defaultValue="" value={udatePatientName} displayEmpty MenuProps={modalMenuProps} onChange={(e) => {
									setUpdatePatientName(e.target.value);
									setUpdateAppointmentData((prev) => ({ ...prev, patient_id: e.target.value }));
								}}>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>Select Patient</MenuItem>
									{patientList.map((items, index) => (
										<MenuItem key={index} value={items?.patient_id}>{items?.Name}</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={4}>
							<Typography sx={modalLabelSx}>Provider Name</Typography>
							<FormControl fullWidth size="small" sx={modalControlSx}>
								<Select defaultValue="" value={updateProvider} displayEmpty MenuProps={modalMenuProps} onChange={(e) => {
									setUpdateProvider(e.target.value);
									setUpdateAppointmentData((prev) => ({ ...prev, provider_id: e.target.value }));
								}}>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>Select Provider</MenuItem>
									{providerList?.map((items, index) => (
										<MenuItem key={index} value={items?.id}>{items?.Fname + ' ' + items?.Lname}</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={4}>
							<Typography sx={modalLabelSx}>Appointment Status</Typography>
							<FormControl fullWidth size="small" sx={modalControlSx}>
								<Select defaultValue="" value={updateAppointmentStatus} displayEmpty MenuProps={modalMenuProps} onChange={(e) => {
									setUpdateAppointmentStatus(e.target.value);
									setUpdateAppointmentData((prev) => ({ ...prev, Status: e.target.value }));
								}}>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>Select Status</MenuItem>
									<MenuItem value={'C'}>Completed</MenuItem>
									<MenuItem value={'D'}>Dismissed</MenuItem>
									<MenuItem value={'O'}>Other</MenuItem>
									<MenuItem value={'P'}>Pending</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={6}>
							<Typography sx={modalLabelSx}>Location</Typography>
							<FormControl fullWidth size="small" sx={modalControlSx}>
								<Select defaultValue="" value={updateLocation} displayEmpty MenuProps={modalMenuProps} onChange={(e) => {
									setUpdateLocation(e.target.value);
									setUpdateAppointmentData((prev) => ({ ...prev, location_id: e.target.value }));
								}}>
									<MenuItem value="" sx={{ color: '#8a9ab5' }}>Select Location</MenuItem>
									{location?.map((items, index) => (
										<MenuItem key={index} value={items?.id}>{items?.Name}</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={6}>
							<Typography sx={modalLabelSx}>Appointment Date & Time</Typography>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DemoContainer components={['DateTimePicker']} sx={{ p: 0 }}>
									<DemoItem>
										<DateTimePicker
											disablePast
											size="small"
											slotProps={{ textField: { size: 'small', sx: modalControlSx, placeholder: 'MM/DD/YYYY hh:mm AM/PM' } }}
											sx={{ width: '100%' }}
											value={selectedDate}
											onChange={(nValue) => {
												setselectedDate(nValue);
												setUpdateAppointmentData((prev) => ({
													...prev,
													AppointmentDate: dayjs(nValue).format('YYYY-MM-DDTHH:mm:ss'),
												}));
											}}
										/>
									</DemoItem>
								</DemoContainer>
							</LocalizationProvider>
						</Grid>
						<Grid item xs={12}>
							<Typography sx={modalLabelSx}>Reason</Typography>
							<Box
								component="textarea"
								name="Reason"
								placeholder="Enter Reason..."
								value={updateReason}
								onChange={(e) => {
									setUpdateReason(e.target.value);
									setUpdateAppointmentData((prev) => ({ ...prev, Reason: e.target.value }));
								}}
								sx={{
									width: '100%',
									minHeight: 92,
									resize: 'vertical',
									border: '1px solid #d6e2f2',
									borderRadius: '8px',
									padding: '12px 14px',
									fontFamily: 'Poppins',
									fontSize: '13px',
									color: '#122b55',
									outline: 'none',
									boxSizing: 'border-box',
									'&::placeholder': { color: '#8a9ab5' },
									'&:focus': { borderColor: '#2E68BA' },
								}}
							/>
						</Grid>
					</Grid>
					<Grid
						item
						sx={{
							display: 'flex',
							justifyContent: 'flex-end',
							gap: '5px',
							padding: '13px 8px 0px 8px',
						}}
						xs={12}
					>
						<Button
							onClick={() => {
								setOpen(false);
							}}
							sx={{
								mb: 1,
								background: '#fff',
								border: '1px solid #cfd8e6',
								color: '#445273',
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 600,
								borderRadius: '10px',
								padding: '10px 26px',
								'&:hover': {
									background: '#f8fbff',
									border: '1px solid #cfd8e6',
								},
							}}
						>
							Cancel
						</Button>

						<Button
							disabled={
								updateAppointmentData?.patient_id === ''
									? true
									: updateAppointmentData?.provider_id === ''
										? true
										: updateAppointmentData?.Status === ''
											? true
											: updateAppointmentData?.Reason === ''
												? true
												: updateAppointmentData?.location_id === ''
													? true
													: updateAppointmentData?.AppointmentDate ==
														  'Invalid Date'
														? true
														: false
							}
							sx={{
								mb: 1,
								background: '#2E68BA',
								border: '1px solid #2E68BA',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 600,
								borderRadius: '10px',
								padding: '10px 26px',
								'&:hover': {
									background: '#265aa8',
									border: '1px solid #265aa8',
								},
							}}
							onClick={() => {
								updateAppointmentInfo(appointmentID, updateAppointmentData);
							}}
						>
							Update Appointment
						</Button>
					</Grid>
				</Box>
			</Modal>
			{/* Delete Modal */}
			<Modal
				open={openDeleteModal.deleteModalOpen}
				onClose={handleCloseDeleteModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						width: 'min(430px, calc(100vw - 32px))',
						bgcolor: '#fff',
						border: '1px solid #dce8f5',
						borderRadius: '10px',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
						outline: 'none',
						overflow: 'hidden',
					}}
				>
					<Box display={'flex'} justifyContent={'flex-end'} sx={{ p: '12px 12px 0' }}>
						<Cancel
							sx={{ cursor: 'pointer', color: '#64748b', fontSize: '20px' }}
							onClick={() => {
								handleCloseDeleteModal();
							}}
						/>
					</Box>
					<Box display={'flex'} flexDirection={'column'} alignItems="center" sx={{ px: 3, pt: 1, pb: 3 }}>
						<Box
							sx={{
								width: 74,
								height: 74,
								borderRadius: '50%',
								background: '#fff1f2',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								mb: 2,
							}}
						>
							<Box
								sx={{
									width: 52,
									height: 52,
									borderRadius: '50%',
									background: '#ffe4e6',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<DeleteIcon sx={{ color: '#ef4444', fontSize: '28px' }} />
							</Box>
						</Box>
						<Typography
							id="modal-modal-title"
							align="center"
							component="h2"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '15px',
								fontWeight: 600,
								color: '#1f2937',
								mb: 1,
							}}
						>
							Are you sure you want to delete this appointment?
						</Typography>
						<Typography
							align="center"
							sx={{
								fontFamily: 'Poppins',
								fontSize: '14px',
								fontWeight: 700,
								color: '#005eff',
								lineHeight: 1.4,
								wordBreak: 'break-word',
							}}
						>
							{openDeleteModal?.deletingName}
						</Typography>
					</Box>
					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: '1fr 1fr',
							gap: 1.5,
							px: 3,
							py: 2.5,
							borderTop: '1px solid #edf2f8',
						}}
					>
						<Button
							variant="contained"
							startIcon={<Cancel sx={{ fontSize: '18px' }} />}
							sx={{
								height: '40px',
								minWidth: 0,
								borderRadius: '6px',
								border: '1px solid #cfd9e8',
								backgroundColor: '#fff',
								color: '#344054',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								boxShadow: 'none',
								'&:hover': {
									backgroundColor: '#f8fafc',
									borderColor: '#b9c6d8',
									boxShadow: 'none',
								},
							}}
							onClick={handleCloseDeleteModal}
						>
							No
						</Button>
						<Button
							variant="contained"
							startIcon={<CheckCircleOutlineIcon sx={{ fontSize: '18px' }} />}
							sx={{
								height: '40px',
								minWidth: 0,
								borderRadius: '6px',
								backgroundColor: '#2f6edb',
								color: '#fff',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
								'&:hover': {
									backgroundColor: '#245fc5',
									boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
								},
							}}
							onClick={() => {
								updateAppointmentInfo(openDeleteModal?.deletingId, {
									Deleted: true,
								});
							}}
						>
							Yes
						</Button>
					</Box>
				</Box>
			</Modal>

			{/* SnackBar */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={1800}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={handleCloseSnackbar}
					severity={!postSucessfully ? 'error' : 'success'}
					variant="filled"
					sx={{
						width: '100%',
						height: '3.5rem',
						textAlign: 'center',
						fontSize: '1.1rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
					action={
						<React.Fragment>
							<span
								onClick={handleCloseSnackbar}
								style={{
									cursor: 'pointer',
									m: 'auto 0',
									fontSize: '13px',
									color: 'rgb(231, 231, 231)',
								}}
							>
								Close
							</span>
						</React.Fragment>
					}
				>
					{!postSucessfully ? 'Error!' : 'Appointment Updated Successfully!'}
				</Alert>
			</Snackbar>
		</Fragment>
	);
}

export default Schedular;
